// # services
import { auth } from '@/services';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('adminEventsController', adminEventsController);

    adminEventsController.$inject = [
        'EventsApi',
        'Events',
        'queryParams',
        'handleError',
        'thisSiteSettings',
        'SettingsApi',
        'alerts',
    ];

    function adminEventsController(
        EventsApi,
        Events,
        queryParams,
        handleError,
        thisSiteSettings,
        SettingsApi,
        alerts,
    ) {
        let vm = this;
        this.$onInit = $onInit;

      // properties
        vm.permissionChecks = {
            canCreateEvents: auth.hasPermission('events.create'),
            canManageEvents: auth.hasPermission('events.manage'),
        };
        vm.isLoading = false;
        vm.events = {};
        vm.filters = {
            status: '',
            title: '',
            include_private: 1,
            page: 1,
            page_size: 15,
            with: ['parent', 'user'],
            sort: 'starts_at',
            order: 'desc',
        };
        vm.statusOptions = [
            {label: 'All', value: ''},
            {label: 'Draft', value: 'draft'},
            {label: 'Pending', value: 'pending'},
            {label: 'Approved', value: 'approved'},
            {label: 'Rejected', value: 'rejected'}
        ];
        vm.editedPendingEvents = []; // holds the ID's of pending events, in case they're approved, so we can add a style

        vm.settings = thisSiteSettings;
        vm.eventAttrs = thisSiteSettings.custom_event_attrs;
        vm.saveSettings = saveSettings;

        // methods
        vm.getEvents = getEvents;
        vm.editEvent = editEvent;
        vm.createEvent = createEvent;

        /**
         * Retrieves events from the api and adds to scope
         * @return {void}
         */
        function getEvents() {
            vm.isLoading = true;
            EventsApi.get(vm.filters, function (response) {
                vm.events = response;
                vm.isLoading = false;
            }, function (err) {
                handleError(err);
                vm.isLoading = false;
            });
        }

        function saveSettings() {
            const data = angular.copy(vm.settings);
            data.custom_event_attrs = generateAttrKeys(vm.eventAttrsCopy);

            SettingsApi.save({ settings: data }, handleSuccess, (resp) => {
                vm.formErrors = resp.data;
            }).suppressValidationAlerts();

            function handleSuccess() {
                alerts.emit({
                    theme: 'success',
                    title: 'Settings Saved',
                    messages: [],
                });
            }
        }

        /**
         * Generates safe attribute keys from the labels
         *
         * @param {Object} attributes - attribute data
         * @return {Object}
         */
        function generateAttrKeys(attributes) {
          attributes.map((obj) => {
            if (obj.custom === true && !obj.key) {

              // generate 'safe' key - alphanumeric
              let safeKey = obj.label.replace(/\W/g, '').toLowerCase();
              const attrKeys = [];

              // grab array of existing attrs to check against
              for (let i = 0; i < attributes.length; i += 1) {
                attrKeys.push(attributes[i].key);
              }

              // if safe key spotted in attr array
              if (attrKeys.indexOf(safeKey) >= 0) {
                let newSafeKey = safeKey;
                let counter = 1;

                while (attrKeys.indexOf(newSafeKey) >= 0) {
                  // if last character is a number
                  // need to check this, otherwise it just adds another '1' and passes
                  if (parseInt(newSafeKey.substr(-1), 10)) {
                    // get last counter of attr key, increment and test again until pass
                    counter = parseInt(newSafeKey.substr(-1), 10);
                    counter += 1;
                    newSafeKey = newSafeKey.substr(0, newSafeKey.length - 1)
                      + counter.toString();
                  } else {
                    newSafeKey = safeKey.concat(counter.toString());
                  }
                }

                safeKey = newSafeKey;
              }

              // add safe key to attr data
              obj.key = safeKey;
            }
          });

          return attributes;
        }

        function $onInit(): void {
            /**
             * Sorry, this is nasty but so is Angular and it doesn't like keeping things in sync...
             * Use vm.userAttrs in the template instead of vm.userAttrs
             */
            vm.eventAttrsCopy = vm.eventAttrs;

            if(vm.eventAttrsCopy == undefined) {
                vm.eventAttrsCopy = [];
            }
        }

        /**
         * Edits the event via a modal, and updates model in this controller
         * @param  {object} event - event object containing id, status
         * @return {void}
         */
        function editEvent(event) {
            if (event.status === 'pending') {
                vm.editedPendingEvents.push(event.id);
            }

            Events.edit(event.id)
                .result.then(function (updatedEvent) {

                    // Find and update the event on this page
                    angular.forEach(vm.events.data, function (event, index) {
                        if (updatedEvent && event.id === updatedEvent.id) {
                            if (vm.editedPendingEvents.indexOf(updatedEvent.id) !== -1 && updatedEvent.status === 'approved') {
                                // this event has been changed from pending to approved
                                updatedEvent.recentlyApproved = true;
                            }

                            vm.events.data[index] = updatedEvent;
                        }
                    });

                }).catch(function (action) {
                    if (action && action === 'deleted') {
                        getEvents();
                    }
                });
        }

        /**
         * Creates an event then refreshes events
         * @return {void}
         */
        function createEvent() {
            Events.create()
                .result.then(function () {
                    getEvents();
                });
        }

        // if ?edit=N is set, show the edit modal
        if (queryParams.edit) {
            editEvent({id: queryParams.edit});
        }
        if (queryParams.create) {
            createEvent();
        }

        // initalise controller
        (function () {
            getEvents();
        }());
    }

}(angular));
